import enhance from './enhancer';
import RootPath from './RootPath.js';

export default enhance(RootPath);
